import { useEffect, useState } from 'react';

import { useParams } from 'react-router-dom';

import useReceiptsTheme from 'api/useReceiptsTheme';

import { defaultReceiptTheme } from './defaults';

export const useGetReceiptInitialValues = () => {
  const { publisherId } = useParams();

  const [initialValues, setInitialValue] = useState(defaultReceiptTheme);

  const { getReceiptTheme } = useReceiptsTheme(publisherId);

  useEffect(() => {
    const receiptTheme = getReceiptTheme?.data?.receiptTheme;
    setInitialValue({
      senderName: receiptTheme?.senderName || '',
      logo: receiptTheme?.logo || defaultReceiptTheme.logo,
      headerImage: receiptTheme?.headerImage || '',
      publisherId: publisherId || '',
      paymentReceiptTemplateName:
        receiptTheme?.paymentReceiptTemplateName || '',
      refundReceiptTemplateName: receiptTheme?.refundReceiptTemplateName || '',
      subscriptionReceiptTemplateName:
        receiptTheme?.subscriptionReceiptTemplateName || '',
      subscriptionRefundReceiptTemplateName:
        receiptTheme?.subscriptionRefundReceiptTemplateName || '',
      supportUrl: receiptTheme?.supportUrl || null
    });
  }, [getReceiptTheme?.data?.receiptTheme]);

  return { initialValues: initialValues || defaultReceiptTheme };
};
